// 0130 · textos del turno compartido y de las excepciones de cierre (los usan varias pantallas).
import type {
  CodigoCausa,
  CodigoSenal,
  ColaRevision,
  MotivoEscalamiento,
  MotivoExcepcion,
  ResolucionExcepcion,
} from '../api/contratos';

export const NOMBRE_MOTIVO: Record<MotivoExcepcion, string> = {
  DIFERENCIA_EFECTIVO: 'diferencia de efectivo',
  MATERIAL: 'diferencia material',
  DIFERENCIA_TARJETA: 'tarjeta no cuadra',
  DIFERENCIA_CHEQUE: 'cheque no cuadra',
  COBRO_ANULADO: 'cobro anulado',
  POST_CLOSE_VOID_EXCEPTION: 'anulada después del cierre (POST_CLOSE_VOID_EXCEPTION)',
  ANULACION_MATERIAL: 'anulación material',
  ANULACION_SIN_SOLICITUD: 'anulación sin solicitud previa',
  ANULACION_NO_VINCULABLE: 'anulación sin venta vinculada',
  ANULACION_CON_DESCUADRE: 'anulación con descuadre',
  ANULACION_MEDIO_NO_CUADRA: 'anulación de un medio que no cuadra',
  ANULACION_VIOLA_POLITICA: 'anulación fuera de la política',
  ANULACION_SENAL: 'señales de anulaciones',
  CORRECCION_POSTERIOR: 'medios corregidos después del cierre',
  CORRECCION_MATERIAL: 'corrección material',
  CORRECCION_CAMBIA_EFECTIVO: 'la corrección cambia el efectivo esperado',
  CORRECCION_TARJETA_CHEQUE: 'la corrección toca tarjeta o cheque',
  CORRECCION_SIN_EVIDENCIA: 'corrección sin causa',
  CORRECCION_VIOLA_POLITICA: 'corrección con causa no permitida',
  CORRECCION_CON_DESCUADRE: 'corrección con descuadre material',
  INCIDENTE_SENSIBLE: 'plata de ruta sin entrar al turno',
  REINCIDENCIA_OPERADOR: 'reincidencia de una persona',
  REINCIDENCIA_CAJA: 'reincidencia de la caja',
  SIN_REVISOR_NIVEL_UNO: 'sin revisor de nivel 1 sin conflicto',
};

/** Por qué una anulación es de nivel 2. */
export const NOMBRE_CAUSA_ANULACION: Record<string, string> = {
  POST_CIERRE: 'después del cierre del turno',
  MATERIAL: 'monto material',
  SIN_SOLICITUD: 'sin solicitud previa',
  NO_VINCULABLE: 'sin venta vinculada',
  DESCUADRE: 'el cierre no cuadró',
  MEDIO_NO_CUADRA: 'el medio anulado no cuadra',
  VIOLA_POLITICA: 'la pidió una cuenta compartida',
  REINCIDENCIA: 'reincidencia',
  SENAL: 'señales que escalan',
};

/** V4 · las señales (no son fraude: avisos para mirar). */
export const NOMBRE_SENAL: Record<CodigoSenal, string> = {
  MULTIPLE_VOIDS_SAME_OPERATOR: 'varias anulaciones de la misma operadora',
  MULTIPLE_VOIDS_SAME_SHIFT: 'varias anulaciones en el turno',
  VOID_AFTER_CLOSE: 'anulada después del cierre',
  HIGH_VALUE_VOID: 'anulación de monto alto',
  VOID_WITHOUT_REQUEST: 'anulada sin solicitud',
  VOID_WITHOUT_LINKED_DOCUMENT: 'anulada sin venta vinculada',
  VOID_PAYMENT_METHOD_MISMATCH: 'el medio anulado no cuadra',
  VOID_AFTER_SETTLEMENT: 'anulada después de la entrega a tesorería',
  REPEATED_VOID_CUSTOMER: 'anulaciones repetidas del mismo cliente',
  EXCEPTIONAL_OPERATOR: 'participó una operadora excepcional',
};

/** V3 · los códigos de causa (un clic), en el orden en que se muestran. */
export const NOMBRE_CAUSA: Record<CodigoCausa, string> = {
  COUNTING_ERROR: 'Error de conteo',
  CHANGE_ERROR: 'Error de vuelto',
  VOIDED_PAYMENT: 'Cobro anulado',
  PAYMENT_METHOD_MISMATCH: 'Medio de pago equivocado',
  ROUTE_CASH: 'Plata de ruta',
  LATE_ENTRY: 'Registro tardío',
  SYSTEM_ERROR: 'Error del sistema',
  AUTHORIZED_CORRECTION: 'Corrección autorizada',
  OTHER: 'Otra (describir)',
};

export const NOMBRE_RESOLUCION: Record<ResolucionExcepcion, string> = {
  JUSTIFICADA: 'Justificada (sin cargo)',
  CARGO_RESPONSABLE: 'Cargo a la responsable',
  ERROR_DE_REGISTRO: 'Error de registro (se corrige)',
  OTRA: 'Otra (solo nivel 2)',
};

export const NOMBRE_ESCALAMIENTO: Record<MotivoEscalamiento, string> = {
  ANULACION_SOSPECHOSA: 'Anulación sospechosa',
  DISCREPANCIA_NO_RESUELTA: 'Diferencia que no se puede explicar',
  EXCEPCION_POLITICA: 'Excepción a la política',
  OTRO: 'Otro (describir)',
};

/** El nombre de la cola según el nivel (los grupos salen de roles asignados, nunca de personas). */
export function nombreCola(nivel: number, cola: ColaRevision | null | undefined): string {
  if (!cola) return '';
  if (nivel === 1) return cola === 'ALTERNO' ? 'tesorería / adm. de cajas' : 'soporte comercial';
  if (cola === 'ALTERNO') return 'alterna de nivel 2';
  if (cola === 'OPEN_REQUIRES_INDEPENDENT_REVIEW') return 'requiere revisión independiente';
  return 'aprobación superior';
}

export const motivosEnTexto = (motivos: readonly string[] = []) =>
  motivos.map((m) => NOMBRE_MOTIVO[m as MotivoExcepcion] ?? m).join(', ');

export const senalesEnTexto = (senales: readonly string[] = []) =>
  senales.map((s) => NOMBRE_SENAL[s as CodigoSenal] ?? s).join(', ');
